'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _ = require('../');

var _RiskTypeLinks = require('./RiskTypeLinks.css');

var _RiskTypeLinks2 = _interopRequireDefault(_RiskTypeLinks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RiskTypeLinks = (_dec = (0, _reactCssModules2.default)(_RiskTypeLinks2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(RiskTypeLinks, _Component);

  function RiskTypeLinks() {
    (0, _classCallCheck3.default)(this, RiskTypeLinks);
    return (0, _possibleConstructorReturn3.default)(this, (RiskTypeLinks.__proto__ || (0, _getPrototypeOf2.default)(RiskTypeLinks)).apply(this, arguments));
  }

  (0, _createClass3.default)(RiskTypeLinks, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'gray-wrap' },
        _react2.default.createElement(
          _.ContainerDivs,
          null,
          _react2.default.createElement(
            'h2',
            { styleName: 'section-lbl' },
            'How unsustainable funds threaten your retirement'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'risk-type-links-flex' },
            _react2.default.createElement(
              'div',
              { styleName: 'risk-type-links-cell-outer' },
              _react2.default.createElement(
                _.Link,
                {
                  to: _config2.default.routes.issues,
                  title: 'Environmental and social impacts'
                },
                _react2.default.createElement(
                  'div',
                  { styleName: 'risk-type-links-cell-inner' },
                  _react2.default.createElement('div', { styleName: 'risk-type-links-image clim' }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'risk-type-links-hl-flex' },
                    _react2.default.createElement(
                      'h3',
                      { styleName: 'risk-type-links-hl' },
                      'Environmental and social impacts'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'risk-type-links-tl' },
                    'We rate retirement plans and mutual funds on environmental and social sustainability issues, from deforestation to gender equality. ',
                    _react2.default.createElement(
                      'span',
                      {
                        styleName: 'risk-type-links-read-more'
                      },
                      'Read more'
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'risk-type-links-cell-outer' },
              _react2.default.createElement(
                _.Link,
                {
                  to: _config2.default.routes.eduCenterFinRisks,
                  title: 'Financial risks of unsustainable investments'
                },
                _react2.default.createElement(
                  'div',
                  { styleName: 'risk-type-links-cell-inner' },
                  _react2.default.createElement('div', { styleName: 'risk-type-links-image fin' }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'risk-type-links-hl-flex' },
                    _react2.default.createElement(
                      'h3',
                      { styleName: 'risk-type-links-hl' },
                      'Financial risks of unsustainable investments'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'risk-type-links-tl' },
                    'Unsustainable investments could be adding financial risk to your 401(k). Learn the facts about sustainable investing and performance. ',
                    _react2.default.createElement(
                      'span',
                      {
                        styleName: 'risk-type-links-read-more'
                      },
                      'Read more'
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return RiskTypeLinks;
}(_react.Component)) || _class);
exports.default = RiskTypeLinks;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/RiskTypeLinks/RiskTypeLinks.js
// module id = 1438
// module chunks = 0